import { Injectable } from "@angular/core";
import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpStatusCode } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { HelperService } from "../services/helper.service";

@Injectable()
export class WebServiceAvailableInterceptor implements HttpInterceptor {
  constructor(private helperService: HelperService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((a) => {
        if (a.type === HttpEventType.Response) {
          if (a.status !== 0 && a.status !== HttpStatusCode.GatewayTimeout) { // ngsw returns 504 Gateway Timeout when the client is offline (https://github.com/angular/angular/issues/46445)
            this.helperService.setOnlineState(true);
          }
        }
      })
    );
  }
}
